// список не пройденных активных опросов для пользователя (должен быть один пока что)
export const SURVEY_LIST = 'SURVEY_LIST';
export const SURVEY_LIST_SUCCESS = 'SURVEY_LIST_SUCCESS';
export const SURVEY_LIST_FAIL = 'SURVEY_LIST_FAIL';
export const SAVE_SURVEY_RESULT = 'SAVE_SURVEY_RESULT';
export const SAVE_SURVEY_RESULT_SUCCESS = 'SAVE_SURVEY_RESULT_SUCCESS';
export const SAVE_SURVEY_RESULT_FAIL = 'SAVE_SURVEY_RESULT_FAIL';
export const GET_LIST_SURVEYS = 'GET_LIST_SURVEYS';
export const GET_LIST_SURVEYS_SUCCESS = 'GET_LIST_SURVEYS_SUCCESS';
export const GET_LIST_SURVEYS_FAIL = 'GET_LIST_SURVEYS_FAIL';
export const GET_SURVEY_RESULT = 'GET_SURVEY_RESULT';
export const GET_SURVEY_RESULT_SUCCESS = 'GET_SURVEY_RESULT_SUCCESS';
export const GET_SURVEY_RESULT_FAIL = 'GET_SURVEY_RESULT_FAIL';
export const ADD_SURVEY = 'ADD_SURVEY';
export const ADD_SURVEY_SUCCESS = 'ADD_SURVEY_SUCCESS';
export const ADD_SURVEY_FAIL = 'ADD_SURVEY_FAIL';
export const TOGGLE_ACTIVATION_SURVEY = 'TOGGLE_ACTIVATION_SURVEY';
export const TOGGLE_ACTIVATION_SURVEY_SUCCESS = 'TOGGLE_ACTIVATION_SURVEY_SUCCESS';
export const TOGGLE_ACTIVATION_SURVEY_FAIL = 'TOGGLE_ACTIVATION_SURVEY_FAIL';
